import { AxiosPromise } from 'axios';
import { http } from 'services';

export interface GenerationFieldOption {
  key: string;
  displayName: string;
  /** Surfaced so the generate UI can pre-fill an editable box; the edited text is re-sanitized server-side. */
  prompt: string;
}

/** The catalogue is global (admin-managed); org context rides the `x-organization-id` header. */
export const GetGenerationFields = (): AxiosPromise<GenerationFieldOption[]> =>
  http.request.get('/api/generation-fields');
